export default __webpack_public_path__ + "static/media/21.8550039d.png";